import React, { useState, useEffect } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js
import { useNavigate, useParams } from 'react-router-dom';

const EditPartyPurchesh = () => {
    // State to manage form fields
    const [description, setDescription] = useState('');
    const [date, setDate] = useState('');
    const [sno, setSno] = useState('');
    const [partyCode, setPartyCode] = useState('');
    const [partyName, setPartyName] = useState('');
    const [discountPercentage, setDiscountPercentage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();
    const { id } = useParams(); // Get the party purchase ID from URL

    // Fetch party purchase data on component mount
    useEffect(() => {
        fetch(`${BASE_URL}partypurchesh/${id}`)
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 'success') {
                    const party = data.data;
                    setDescription(party.description);
                    setDate(party.date.split('T')[0]); // Format the date to YYYY-MM-DD
                    setSno(party.sno);
                    setPartyCode(party.party_code);
                    setPartyName(party.party_name);
                    setDiscountPercentage(party.discount_percentage);
                } else {
                    setErrorMessage('Failed to fetch party purchase data.');
                }
            })
            .catch((error) => setErrorMessage('Error: ' + error.message));
    }, [id]);

    // Handle form submission
    const handleSubmit = (event) => {
        event.preventDefault();

        // Validation
        if (!description || !date || !partyCode || !partyName || !discountPercentage) {
            setErrorMessage('Please fill in all the fields.');
            return;
        }

        // Prepare data to send in the PUT request
        const partyPurcheshData = {
            description,
            date,
            sno,
            party_code: partyCode,
            party_name: partyName,
            discount_percentage: parseFloat(discountPercentage),
        };

        // Send PUT request to update party purchase
        fetch(`${BASE_URL}partypurchesh/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(partyPurcheshData),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 'success') {
                    // Redirect to PartyPurcheshList after successful update
                    navigate('/PartyPurcheshList');
                } else {
                    setErrorMessage('Failed to update Party Purchase. Please try again.');
                }
            })
            .catch((error) => {
                setErrorMessage('Error: ' + error.message);
            });
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit Party Purchase</h3>
                        </div>
                    </div>
                </div>
            </div>

            {/* Edit Party Purchase Form */}
            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Edit Party Purchase Details</h4>
                            </div>
                            <div className="card-body">
                                {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="description" className="form-label">Description</label>
                                        <input
                                            type="text"
                                            id="description"
                                            className="form-control"
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                            placeholder="Enter description"
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="date" className="form-label">Date</label>
                                        <input
                                            type="date"
                                            id="date"
                                            className="form-control"
                                            value={date}
                                            onChange={(e) => setDate(e.target.value)}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="sno" className="form-label">SNO</label>
                                        <input
                                            type="number"
                                            id="sno"
                                            className="form-control"
                                            value={sno}
                                            onChange={(e) => setSno(e.target.value)}
                                            placeholder="Enter SNO"
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="partyCode" className="form-label">Party Code</label>
                                        <input
                                            type="text"
                                            id="partyCode"
                                            className="form-control"
                                            value={partyCode}
                                            onChange={(e) => setPartyCode(e.target.value)}
                                            placeholder="Enter party code"
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="partyName" className="form-label">Party Name</label>
                                        <input
                                            type="text"
                                            id="partyName"
                                            className="form-control"
                                            value={partyName}
                                            onChange={(e) => setPartyName(e.target.value)}
                                            placeholder="Enter party name"
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="discountPercentage" className="form-label">Discount Percentage</label>
                                        <input
                                            type="number"
                                            id="discountPercentage"
                                            className="form-control"
                                            value={discountPercentage}
                                            onChange={(e) => setDiscountPercentage(e.target.value)}
                                            placeholder="Enter discount percentage"
                                        />
                                    </div>
                                    <div className="mb-3 text-end">
                                        <button type="submit" className="btn btn-primary">Update</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EditPartyPurchesh;
